import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import { Typography, notification} from "antd";
import * as XLSX from 'xlsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';  
import { list } from "../../../controllers/transactionController";

import Loading from "../../../components/Loading/LoadingEffect";
import { Link } from "react-router-dom";
import moment from "moment";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
const VendorListDeletePopUp = ({ popUpOpen, togglePopUp, user_id }) => {
  const handleCancel = () =>  togglePopUp();
  const [filter, setFilter] =useState({
    from_date : moment().subtract(7, 'days').format('YYYY-MM-DD'),
    from_time : "21:30",
    to_date : moment().format('YYYY-MM-DD'),
    to_time : "21:31"
  })

  const handleFilterChange = async (e) =>{
    try {
      const {name, value} = e.target;
      setFilter((pre)=>({
        ...pre,
        [name] : value
      }))
    } catch (error) {
      
    }
  }

  const [isLoading, setIsLoading] = useState(false);
  
  const handleExport = async (e) => {
    e.preventDefault(0);
    try {
      if(!user_id){
        notification.open({
            message: "Oops!",
            description: `Please select customer.`,
            placement: "topRight",
            icon: <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle} />,
            duration: 2,
          });
      } else {
        setIsLoading(true);
        const option = {
          condition : { 
            $or : [
              { credit_user : user_id },
              { debit_user : user_id }
            ],
            createdAt : {$gte : `${filter?.from_date} ${filter?.from_time}`, $lte : `${filter?.to_date} ${filter?.to_time}` }
           },
           select : {},
           sort : {_id : -1}
        }
        const res = await list(option);
        if(res.status === true && res.result?.length > 0){
           
          let modifiedData = res?.result.map((items, index) => ({
              "Sl. No"            : index + 1,
              ...(items?.record_type === 'Credit' && {
                "Name" : `${items?.credit_user?.users_name} ${items?.credit_user?.last_name}`,
                "Mobile" : `${items?.credit_user?.users_mobile}`,
                "Area" : `${items?.credit_user?.area}`
              }),
              ...(items?.record_type === 'Debit' && {
                "Name" : `${items?.debit_user?.users_name} ${items?.debit_user?.last_name}`,
                "Mobile" : `${items?.debit_user?.users_mobile}`,
                "Area" : `${items?.debit_user?.area}`
              }),
              "Before Amount"       : items?.before_amount,
              "Amount"              : items?.amount,
              "After Amount"        : items?.after_amount,
              "Narration"           : items?.narration,
              "Record Type"         : items?.record_type,
              ...(items?.from_user ? {
                "From"                : `${items?.from_user?.users_name} ${items?.from_user?.last_name} (${items?.from_user?.users_mobile})`
              }:{"From" : `${items?.created_by_users_type}`}),
              "Date"                : moment(items?.createdAt).format('YYYY-MM-DD HH:mm:ss')
            }));
            if(modifiedData && modifiedData?.length >0){
              await exportToExcel(modifiedData);
            }
            handleCancel();
        } else{
          notification.open({
            message: "Oops!",
            description: `Zero records found.`,
            placement: "topRight",
            icon: <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle} />,
            duration: 2,
          });
        }
      }
    } catch (error) {
      setIsLoading(false);
    } finally {
        setIsLoading(false);
    }
  }

  const exportToExcel = async (data) => {
    try {
      const workbook = XLSX.utils.book_new();
      const worksheet1 = XLSX.utils.json_to_sheet(data);

      XLSX.utils.book_append_sheet(workbook, worksheet1, "Due");
      XLSX.writeFile(workbook, `${new Date()}.xlsx`);
    } catch (error) {
      alert(JSON.stringify(error));
    } finally {
      setIsLoading(false);
    }
  };
  
  return (
    <Dialog
      open={popUpOpen}
      onClose={handleCancel}
      fullWidth={true}
      maxWidth={"md"}
      PaperProps={{
        className: "myDialogPopUp",
      }}
    >
      <div className="myDrawer">
        
        <div className="myDrawer">
          <div className="inventory_popup_title">
            <Typography
              variant="h5"
              component="div"
              gutterBottom
              className="inventory_popup_title_heading"
            >
              Export transaction's history
            </Typography>
            <Link to={false} style={{ position: "absolute", right: 8, top: 8, color: "#dd5151" }} onClick={handleCancel}><FontAwesomeIcon icon={faTimesCircle}/></Link>
          </div>

          <Typography
            variant="body1"
            component="div"
            className="my_delete_popup_paragraph"
          >
          </Typography>
         
          <Typography
            variant="body1"
            component="div"
            className="my_delete_popup_paragraph"
          >
            <div className="container-fluid">
              <div className="categories_open_popup_main_contnet">
                <form onSubmit={handleExport}>
                  <div className="form-group row">
                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <label for="from_date" className="all_lable_for_vendor_dashbaord" > From Date : </label>
                      <input type="date" name="from_date" onChange={handleFilterChange} id="from_date" value={filter?.from_date} class="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <label for="from_time" className="all_lable_for_vendor_dashbaord" > From Time : </label>
                      <input type="time" name="from_time" id="from_time" onChange={handleFilterChange} value={filter?.from_time} class="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-6 col-md-5 col-sm-12 col-xs-12">
                      <label for="to_date" className="all_lable_for_vendor_dashbaord" > To Date : </label>
                      <input type="date" name="to_date" id="to_date" onChange={handleFilterChange} value={filter?.to_date} class="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <label for="to_time" className="all_lable_for_vendor_dashbaord" > To Time : </label>
                      <input type="time" name="to_time" id="to_time" onChange={handleFilterChange} value={filter?.to_time} class="form-control categories_select_tg_enter_product" />
                    </div>


                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <div className="inventory_open_popup_action_btn">
                        <button type="button" className="btn btn-light categories_cancel_button" onClick={handleCancel} > Cancel </button>
                        <button type="submit" className="btn btn-danger" > Download Excel </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </Typography>
        </div>
      </div>
      <Loading isLoading={isLoading} text={`Preparing download...`} />
    </Dialog>
  );
};

export default VendorListDeletePopUp;
